import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=05f9fd28&"
import script from "./DropdownItem.vue?vue&type=script&lang=js&"
export * from "./DropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports